"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
exports.notify = notify;
const React = __importStar(require("react"));
const zustand_1 = require("zustand");
const components_1 = require("@smapiot/components");
const useNotifications = (0, zustand_1.create)((set, get) => ({
    items: [],
    append(item) {
        var _a;
        const timeout = typeof item.autoClose === 'boolean' ? (item.autoClose ? 4000 : -1) : ((_a = item.autoClose) !== null && _a !== void 0 ? _a : -1);
        set((store) => (Object.assign(Object.assign({}, store), { items: [...store.items, item] })));
        if (timeout > 0) {
            setTimeout(() => get().remove(item), timeout);
        }
    },
    remove(item) {
        set((store) => (Object.assign(Object.assign({}, store), { items: store.items.filter((m) => m !== item) })));
    },
}));
function notify(details) {
    const { append } = useNotifications.getState();
    append(details);
}
const Notifications = () => {
    const notifications = useNotifications();
    return (React.createElement(components_1.NotificationsContainer, null, notifications.items.map((notification, index) => (React.createElement(components_1.NotificationsItem, { key: index, id: index.toString(), title: notification.title, kind: notification.kind, close: () => notifications.remove(notification) }, notification.content)))));
};
exports.Notifications = Notifications;
